import { render, staticRenderFns } from "./ServiceButtonListParts.vue?vue&type=template&id=53914a66&scoped=true"
import script from "./ServiceButtonListParts.vue?vue&type=script&lang=ts"
export * from "./ServiceButtonListParts.vue?vue&type=script&lang=ts"
import style0 from "./ServiceButtonListParts.vue?vue&type=style&index=0&id=53914a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53914a66",
  null
  
)

export default component.exports